import {createStore} from 'vuex'
import user from '@/store/user'
import reseller from '@/store/reseller'
import dash from '@/store/dash'
import channels from '@/store/channels'
import integrations from '@/store/integrations'
import automations from '@/store/automations'
import automationsmodels from '@/store/automationsmodels'
import satisfactionSurvey from '@/store/satisfaction-survey'
import debug from '@/store/debug'
import changeLog from '@/store/changeLog'
import logs from '@/store/logs'
import configurations from '@/store/configurations';
import tags from '@/store/tags';
import tickets from '@/store/tickets';

export default createStore({
    state: {},
    mutations: {},
    actions: {},
    modules: {
        user,
        reseller,
        dash,
        channels,
        integrations,
        automations,
        automationsmodels,
        debug,
        satisfactionSurvey,
        changeLog,
        logs,
        configurations,
        tags,
        tickets,
    },
})